import { GetServerSideProps } from 'next';

import createApolloClient from 'src/modules/ApolloWrapper/createApolloClient';
import {
  GetCustomSlugPagesWithActiveJobsData,
  queryCustomSlugPagesWithActiveJobs,
} from 'src/modules/Seo/graphql';
import { JobsByCustomSlugPages } from 'src/modules/Seo/JobsByCustomSlugPages';

export default JobsByCustomSlugPages;

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { req, res, query } = context;
  const page = Number(query?.page) || 1;

  res.setHeader(
    'Cache-Control',
    'public, s-maxage=3600, stale-while-revalidate=3599'
  );

  const { dstContext } = req;
  const { clientConfig } = dstContext;
  const { COUNTRY: country } = clientConfig;

  const apolloClient = createApolloClient({
    listenPort: dstContext.listenPort,
    token: dstContext.accessToken,
    cookie: req.headers.cookie,
    ssrToken: dstContext.ssrToken,
    remoteAddress: dstContext.remoteAddress,
    xForwardedFor: req.headers['x-forwarded-for'],
    locale: clientConfig?.LANG,
    country: clientConfig?.COUNTRY,
  });

  let initialFindJobsData = null;
  try {
    const { data: jobsData } =
      await apolloClient.query<GetCustomSlugPagesWithActiveJobsData>({
        query: queryCustomSlugPagesWithActiveJobs,
        variables: {
          countryCode: country,
          pageSize: 60,
          currentPage: page,
        },
      });
    initialFindJobsData = jobsData;
  } catch (error) {
    console.error('Error fetching find jobs page', error);
  }

  return {
    props: {
      initialFindJobsData,
    },
  };
};
